import { routes } from '@services/sections/modal'
import { BlockchainAddressStatus } from '@shared/graphql'

export const PENDING_INFO_STATES = [
  BlockchainAddressStatus.PENDING_ADDITIONAL_INFORMATION,
  BlockchainAddressStatus.PENDING_BENEFICIARY_INFORMATION,
]

export const PENDING_ADDRESS_STATES = [
  ...PENDING_INFO_STATES,
  BlockchainAddressStatus.PENDING_VERIFICATION,
]

/**
 * Returns next modal path in the add address flow based on address status.
 */
export const getAddAddressModalPathByStatus = (
  status: BlockchainAddressStatus,
) => {
  switch (status) {
    case BlockchainAddressStatus.PENDING_BENEFICIARY_INFORMATION:
      return routes.account.addressBook.addNewAddress.beneficiaryInfo
    case BlockchainAddressStatus.PENDING_ADDITIONAL_INFORMATION:
      return routes.account.addressBook.addNewAddress.additionalWalletInfo
    case BlockchainAddressStatus.PENDING_VERIFICATION:
      return routes.account.addressBook.verifyAddress.identityChallenge
    case BlockchainAddressStatus.ACTIVE:
    case BlockchainAddressStatus.ON_HOLD:
    case BlockchainAddressStatus.UNSUPPORTED:
      return routes.account.addressBook.addNewAddress.success
  }
}
